import odinIcon from '../assets/odin-icon.svg';
import React, { Component } from 'react';
export default class Porfolio extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1>Check Out Some of My Works.</h1>
          <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf" style={{height:'100px'}}>
          {
            resumeData.portfolio && resumeData.portfolio.map((item)=>{
              return(
                <div className="columns portfolio-item" >

                  <a href="https://odin.frankzhang.dev" target="_blank" rel="noopener noreferrer">
                  <div className="item-wrap" style={{height:'100px', background:'none'}}>
                    
                      <div style={{display:'flex',}}><img src={odinIcon} className="item-img"/>
                      <h5 style={{color:'grey', marginLeft:'10px'}}>Project Odin</h5></div>
                      <div className="overlay">
                        <div className="portfolio-item-meta">
                          <h5>{item.name}</h5>
                          <p>{item.description}</p>
                        </div>
                      </div>

                  </div>
                  </a>
                </div>
              )
            })
          }
          </div>
        </div>
      </div>
  </section>
        );
  }
}